export const usernamePasswordValidate = (
	username: any,
	password: any
): { valid: boolean; message: string } => {
	if (username.includes(" ")) {
		return { valid: false, message: "Username nuk duhet te ketë hapsirë" };
	}

	if (password === "") {
		return { valid: false, message: "Fjalëkalimi nuk mund të jetë bosh" };
	}

	const hasUpperCase = /[A-Z]/.test(password);
	const hasNumber = /[0-9]/.test(password);
	const isValidLength = password.length >= 8;

	if (!hasUpperCase || !hasNumber || !isValidLength) {
		return {
			valid: false,
			message:
				"Fjalëkalimi duhet të jetë së paku 8 karaktere dhe të përfshijë një shkronjë të madhe dhe një numër.",
		};
	}

	return { valid: true, message: "" };
};
